var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-m-empty-state"},[_c('div',{staticClass:"c-m-empty-state__inner"},[(_vm.icon)?_c('icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.heading)?_c('p',{staticClass:"c-m-empty-state__heading h2"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),(_vm.body)?_c('div',{staticClass:"c-m-empty-state__body",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae2c67f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/molecules/MoleculeEmptyState.vue
// module id = 1180
// module chunks = 0